var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPdffile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 18,
    viewBox: "0 0 15 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7075 4.793L10.2075 0.293C10.027 0.1125 9.77653 0 9.50003 0C8.94803 0 8.50053 0.448 8.50003 1C8.50003 1.276 8.61203 1.5265 8.79303 1.7075L6.86353 3.637L11.3635 8.137L13.293 6.2075C13.474 6.388 13.724 6.5 14 6.5C14.552 6.5 15.0005 6.052 15 5.5C15 5.224 14.888 4.974 14.7075 4.793Z",
    fill: "#E1E8ED"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 0H2C0.8955 0 0 0.8955 0 2V16C0 17.1045 0.8955 18 2 18H13C14.1045 18 15 17.1045 15 16V5.5H10.5C10 5.5 9.5 5 9.5 4.5V0Z",
    fill: "#CCD6DD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 0H8.5V4.5C8.5 5.6045 9.3955 6.5 10.5 6.5H15V5.5H10.5C10 5.5 9.5 5 9.5 4.5V0ZM7 4C7 4.276 6.776 4.5 6.5 4.5H2.5C2.224 4.5 2 4.276 2 4C2 3.724 2.224 3.5 2.5 3.5H6.5C6.776 3.5 7 3.724 7 4ZM7 6C7 6.276 6.776 6.5 6.5 6.5H2.5C2.224 6.5 2 6.276 2 6C2 5.724 2.224 5.5 2.5 5.5H6.5C6.776 5.5 7 5.724 7 6ZM13 8C13 8.276 12.7765 8.5 12.5 8.5H2.5C2.224 8.5 2 8.276 2 8C2 7.724 2.224 7.5 2.5 7.5H12.5C12.7765 7.5 13 7.724 13 8ZM13 10C13 10.2765 12.7765 10.5 12.5 10.5H2.5C2.224 10.5 2 10.2765 2 10C2 9.7235 2.224 9.5 2.5 9.5H12.5C12.7765 9.5 13 9.7235 13 10ZM13 12C13 12.2765 12.7765 12.5 12.5 12.5H2.5C2.224 12.5 2 12.2765 2 12C2 11.7235 2.224 11.5 2.5 11.5H12.5C12.7765 11.5 13 11.7235 13 12ZM13 14C13 14.2765 12.7765 14.5 12.5 14.5H2.5C2.224 14.5 2 14.2765 2 14C2 13.7235 2.224 13.5 2.5 13.5H12.5C12.7765 13.5 13 13.7235 13 14Z",
    fill: "#99AAB5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdffile);
export default __webpack_public_path__ + "static/media/pdffile.47e09b90d7ce542c851d9e83ed5cb7d9.svg";
export { ForwardRef as ReactComponent };